export default "__VITE_ASSET__DLteQfMJ__"